<template>
  <span>
    <i v-if="event.status === 0" class="text-success ti-control-pause" title="Programado"></i>
    <i v-if="event.status === 1" class="text-success ti-control-play" title="Iniciado"></i>
    <i v-if="event.status === 2" class="text-danter ti-control-stop" title="Finalizado"></i>
    <i v-if="event.directList === true" class="text-info ti-list-ol" title="Lista direta"></i>
  </span>
</template>

<script>
export default {
  name: 'event-icon',
  props: {
    event: {
      default: {}
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/EventIcons.vue